import { useState } from 'react'
import { Button, Typography } from '@material-ui/core'
import { textFilter } from 'utils/table'
import { dateTimeToString } from 'utils/date'
import SearchInput from 'elements/SearchInput/SearchInput'
import LoadingButton from 'elements/LoadingButton/LoadingButton'
import { useOrderedSockets } from './hooks/useOrderedSockets'
import InformationTable from 'components/InformationTable/InformationTable'
import ProfileLink from './components/ProfileLink'
import { useSocketData } from './hooks/useSocketData'
import { getTooltipInfo } from './utils/socketHelpers'
import LogTimeAnalyzer from './LogTimeAnalyzer'
import Tag from './components/Tag'
import styles from './ClientesConectados.module.css'

const ClientesConectados = () => {
  const [search, setSearch] = useState('')
  const [showModal, setShowModal] = useState(false)

  const { sockets, loading, disconnect } = useSocketData()

  const orderedData = useOrderedSockets(sockets)

  const filterSearch = live => {
    return textFilter({
      object: live,
      fields: ['name', 'role', 'accessType', 'device'],
      search: search
    })
  }

  return (
    <div>
      <div className={styles.toolbar}>
        <SearchInput value={search} onChange={e => setSearch(e.target.value)} />
        <LoadingButton
          label='Intervalos de tiempo'
          startIcon={<i className='material-icons'>av_timer</i>}
          variant='outlined'
          onClick={() => setShowModal(true)}
          disabled
        />
        <Typography variant='button' color='textSecondary'>
          Hay {orderedData.length} usuarios conectados
        </Typography>
      </div>
      <InformationTable
        className={styles.table}
        isFetching={loading}
        size='small'
        details={[
          { title: 'Nombre', key: 'name', align: 'left' },
          { title: 'Info', key: 'info', sortDisabled: true, align: 'center' },
          { title: 'Dispositivo', key: 'device' },
          { title: 'Asignatura', key: 'attendance' },
          { title: 'Hora conexión', key: 'connectionTS', sortDisabled: true },
          { title: 'Opciones', key: 'options', sortDisabled: true }
        ]}
        data={orderedData.filter(filterSearch).map(socket => ({
          _id: socket._id,
          name: (
            <ProfileLink
              _id={socket._id}
              name={socket.name}
              role={socket.role}
              info={getTooltipInfo(socket, sockets)}
            />
          ),
          info: <Tag socket={socket} />,
          device: socket.device,
          attendance: socket.attendance?.subjectName || '--',
          connectionTS: dateTimeToString(socket.connectionTS),
          options: (
            <Button color='primary' onClick={() => disconnect(socket)}>
              Desconectar
            </Button>
          ),
          style: socket.customStyle
        }))}
      />
      {showModal && <LogTimeAnalyzer onClose={() => setShowModal(false)} />}
    </div>
  )
}

export default ClientesConectados
